import moment from 'moment';

function blankForm() {
  return {
    id: null,
    scheduleId: null,
    type: 'surgery',
    startDate: '',
    endDate: '',
    patient: {
      canSave: false,
      image: {
        file: null,
        preview: null,
        showOptions: false,
        showWebCam: false,
      },
      id: null,
      name: '',
      birthDate: '',
      gender: '',
      identity: {
        type: '',
        value: '',
      },
      phone: '',
      cellphone: '',
      email: '',
      insurance: {
        id: '',
        name: '',
        record: '',
        validity: '',
        plan: {
          id: '',
          name: '',
        },
      },
      address: {
        id: '',
        type: '',
        postalCode: '',
        addressLine1: '',
        addressLine2: '',
        neighborhood: '',
        city: '',
        state: '',
      },
      imageUrl: '',
      notes: '',
    },
    insurance: {
      id: '',
      name: '',
      record: '',
      validity: '',
      plan: {
        id: '',
        name: '',
      },
    },
    professional: {
      id: '',
      name: '',
      council: {
        record: '',
        name: '',
        state: '',
      },
      specialty: '',
    },
    expenses: [],
    status: 'scheduled',
    notes: '',
    arrivedAt: null,
    key: null,
    slot: false,
    reserves: 1,
    indicated: {
      id: '',
      entityId: '',
      name: '',
      type: '',
      council: {
        name: 'CRM',
        state: 'PR',
        record: '',
      },
    },
    surgery: {
      team: [],
      description: '',
    },
  };
}

function blankFilter() {
  return {
    date: moment().toDate(),
    expenses: [],
    expenseId: '',
    insurances: [],
    insuranceId: '',
    schedules: [],
    scheduleId: '631f7b7ee26d700325bbaab6',
    professionalId: '',
    search: '',
    hours: '',
  };
}

export default {
  show: false,
  accountShow: false,
  searchShow: false,
  printShow: false,
  slotShow: false,
  schedules: [],
  professionals: [],
  insurances: [],
  items: [],
  loading: false,
  showFiles: false,
  showHistory: false,
  blankForm,
  form: blankForm(),
  currentMonth: null,
  available: {
    days: [],
    professionals: [],
    insurancePlans: [],
  },
  blankFilter,
  filter: blankFilter(),
  clipboard: {
    event: null,
    data: null,
  },
};
